















































import { computed, defineComponent } from '@vue/composition-api';
import { AlertSortingOption } from '../constants/alert-sorting-options.constants';
import { SearchBox, SvgImage, SortToggle } from '@/app/components';
import { AlertCard, FakeAlertCard } from '../components';
import { useAlerts } from '../composable';
import { useRouter } from '@/app/composable/router';
import { SortToggleOption } from '@/app/types';

export default defineComponent({
    name: 'CustomAlerts',
    components: {
        SearchBox,
        SortToggle,
        AlertCard,
        SvgImage,
        FakeAlertCard,
    },

    setup(props, { root }) {
        const router = useRouter();

        const {
            alerts,
            ALERTS_MAX_NUM,
            deleteAlert,
            toggleAlert,
            total,
            searchedAlerts,
            query,
            fetchAlerts,
            loading,
            alertsLoading,
            sortByKeyAndDirection,
        } = useAlerts(root);

        const sortingFields = AlertSortingOption.all();

        const editAlert = (id: string) => {
            router.push({ name: 'alerts:edit', params: { id } });
        };

        const sortToggle = computed({
            get: (): { key: string; direction: string } => {
                return {
                    key: query.value.sortBy.field,
                    direction: query.value.sortBy.direction,
                };
            },
            set: (updatedSort: { key: string; direction: string }) => {
                sortByKeyAndDirection(updatedSort);
            },
        });

        const sortToggleOptions: SortToggleOption[] = [
            {
                key: 'createdAt',
                directions: [
                    { label: 'Last updated', direction: 'desc' },
                    { label: 'Oldest updated', direction: 'asc' },
                ],
            },
            {
                key: 'name',
                directions: [
                    { label: 'Name A-Z', direction: 'asc' },
                    { label: 'Name Z-A', direction: 'desc' },
                ],
            },
        ];
        fetchAlerts();

        return {
            alerts,
            query,
            sortingFields,
            ALERTS_MAX_NUM,
            editAlert,
            deleteAlert,
            toggleAlert,
            total,
            searchedAlerts,
            loading,
            alertsLoading,
            sortToggleOptions,
            sortToggle,
        };
    },
});
